import * as yup from "yup";

const logoSchema = yup.object().shape({
  file: yup
    .mixed()
    // .required("Image Size is 50px only.")
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    }),
  // url: yup.string(),
  link: yup.string().url("Invalid URL format").required(""),
  image: yup.string(),
  alt: yup.string().required(""),
  target: yup.string().required(""),
});

const logoSchemas = yup.object().shape({
  file: yup
    .mixed()
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    })
    .nullable(),
  // url: yup.string(),
  link: yup.string().url("Invalid URL format").nullable(), 
  image: yup.string(),
  alt: yup.string(),
  target: yup.string(),
}).notRequired();



const logoSchemaSEO = yup.object().shape({
  file: yup
    .mixed()
    .nullable()
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    }),
}).notRequired();

const navListSchema = yup.array().of(
  yup.object().shape({
    text: yup.string(),
    link: yup.string().url("Invalid URL format"),
    target: yup.string().when('link', {
      is: (link) => !!link, // Check if link is a truthy value
      then: (schema) => schema.required("Order is required when link is provided"),
      otherwise: (schema) => schema.notRequired(),
    }),
    order: yup.number().when('text', {
      is: (text) => !!text, // Check if link is a truthy value
      then: (schema) => schema.required("Order is required when text is provided"),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
).notRequired();


const schema = yup.object().shape({
  left_nav_logo: logoSchema,
  navList: navListSchema,
  uiType: yup.string().required("UI Type is required"),
  campaign_type: yup.string().required("Campaign Type is required"),
  nav_right_logo: logoSchemas,
  seo_title: yup.string(),
  seo_description: yup.string(),
  seo_keywords: yup.string(),
  share_image:  logoSchemaSEO,
  favicon:logoSchemaSEO,
  pay_method:yup.string(), 
  share_title: yup.string(),
  share_description: yup.string(),
  seoDone: yup.boolean(),
});

export default schema;